import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutDashboardIcon } from 'lucide-react';
import { MessageAttachments } from '../../ChatMessage/MessageAttachments';
import { UserBubbleProps } from '../ChatBubble.types';

export const UserBubble = memo((props: UserBubbleProps) => {
  const { t } = useTranslation('chats');
  const { content, files } = props;
  const widgetAction = props.metadata?.widgetAction;
  return (
    <div className="my-10">
      <div className="ml-auto mr-0">
        <MessageAttachments
          files={files}
          projectContext={props.metadata?.projectContext}
          type="user"
        />
      </div>
      {widgetAction && (
        <p className="mb-1 ml-auto mr-0 flex w-fit items-center gap-1 text-xs text-muted-foreground">
          <LayoutDashboardIcon className="size-3.5" aria-hidden />
          {widgetAction.title
            ? t('chats.htmlWidget.fromNamedWidget', { title: widgetAction.title })
            : t('chats.htmlWidget.fromWidget')}
        </p>
      )}
      <p
        data-testid="user-bubble"
        className="ml-auto mr-0 w-fit max-w-[70%] whitespace-pre-wrap break-words rounded-xl rounded-tr-none bg-theme-background px-4 py-3 text-base leading-6 text-foreground"
      >
        {content}
      </p>
    </div>
  );
});
UserBubble.displayName = 'UserBubble';
